var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"fixed top-0 left-0 w-full z-50"},[_c('Banners',{on:{"bannersActivated":function($event){_vm.bannersActivated = $event}}}),_c('Header')],1),_c('div',{class:[_vm.bannersActivated ? 'pt-24' : 'pt-16']})])}
var staticRenderFns = []

export { render, staticRenderFns }